import React, { useCallback } from 'react';
import useFocusTrap from '../hooks/useFocusTrap';
import './ConfirmModal.css';

const ConfirmModal = ({
  title,
  message,
  confirmText,
  cancelText,
  danger,
  onConfirm,
  onCancel
}) => {
  const handleEscape = useCallback(() => onCancel(), [onCancel]);
  const dialogRef = useFocusTrap(true, { onEscape: handleEscape });

  return (
    <div
      className="confirm-overlay"
      onClick={(e) => e.target === e.currentTarget && onCancel()}
    >
      <div
        ref={dialogRef}
        className="confirm-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirm-title"
        aria-describedby="confirm-message"
      >
        <h2 id="confirm-title" className="confirm-title">{title}</h2>
        <p id="confirm-message" className="confirm-message">{message}</p>
        <div className="confirm-actions">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={onCancel}
            data-autofocus
          >
            {cancelText}
          </button>
          <button
            type="button"
            className={danger ? 'btn btn-danger' : 'btn btn-primary'}
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
